import { makeStyles } from '@material-ui/core/styles';

const ACCENT = '#010134';

export const useStyles = makeStyles(() => ({
    paper: {
        width: 540,
        maxWidth: '540px',
        borderRadius: 4,
        boxShadow: '0 24px 64px rgba(0,0,40,.18)',
        overflow: 'hidden',
        padding: 0,
    },

    /* ——— Header (pick / payment) ——— */
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '24px 28px',
        borderBottom: '1px solid #f0f0f3',
    },
    title: {
        fontSize: 22,
        fontWeight: 700,
        color: '#1a1a2f',
        letterSpacing: '-0.01em',
        lineHeight: 1.2,
    },
    subtitle: {
        marginTop: 2,
        fontSize: 13,
        color: '#8a8a93',
    },
    closeButton: {
        color: '#8a8a93',
    },
    body: {
        padding: '24px 28px',
    },

    /* ——— Current balance ——— */
    balanceBox: {
        backgroundColor: '#f7f7f9',
        borderRadius: 10,
        padding: '14px 18px',
        marginBottom: 22,
    },
    balanceLabel: {
        fontSize: 11,
        letterSpacing: '.08em',
        textTransform: 'uppercase',
        color: '#8a8a93',
        fontWeight: 600,
        marginBottom: 8,
    },
    balanceRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8,
    },
    balanceUsed: {
        fontSize: 13,
        color: '#4a4a52',
    },
    balanceRemaining: {
        fontSize: 13,
        fontWeight: 600,
        color: '#00793a',
    },
    barTrack: {
        height: 6,
        borderRadius: 999,
        backgroundColor: '#e4e4e8',
        overflow: 'hidden',
    },
    barFill: {
        height: '100%',
        borderRadius: 999,
        backgroundColor: ACCENT,
    },
    balanceNote: {
        fontSize: 11,
        color: '#8a8a93',
        marginTop: 8,
    },

    /* ——— Bundle picker ——— */
    sectionLabel: {
        fontSize: 12,
        fontWeight: 600,
        color: '#4a4a52',
        marginBottom: 12,
    },
    bundleCard: {
        border: `2px solid ${ACCENT}`,
        borderRadius: 12,
        padding: '18px 20px',
        marginBottom: 22,
        backgroundColor: '#f5f5fb',
    },
    bundleRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 16,
    },
    bundleName: {
        fontSize: 16,
        fontWeight: 700,
        letterSpacing: '-0.01em',
        color: '#1a1a2f',
    },
    bundleSub: {
        fontSize: 12,
        color: '#8a8a93',
        marginTop: 2,
    },
    stepper: {
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #d0d0da',
        borderRadius: 10,
        backgroundColor: '#fff',
        overflow: 'hidden',
    },
    stepperBtn: {
        width: 38,
        height: 40,
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        fontSize: 20,
        color: '#4a4a52',
        fontFamily: 'inherit',
        lineHeight: 1,
        '&:disabled': {
            color: '#c4c4cc',
            cursor: 'not-allowed',
        },
    },
    stepperInput: {
        width: 56,
        height: 40,
        border: 'none',
        borderLeft: '1px solid #ededf2',
        borderRight: '1px solid #ededf2',
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 700,
        color: '#1a1a2f',
        fontFamily: 'inherit',
        MozAppearance: 'textfield',
        '&::-webkit-outer-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
        '&::-webkit-inner-spin-button': {
            WebkitAppearance: 'none',
            margin: 0,
        },
    },
    bundleTotalRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        borderTop: '1px solid #e0e0ea',
        paddingTop: 14,
    },
    bundleTxns: {
        fontSize: 14,
        color: '#4a4a52',
    },
    bundleTxnsStrong: {
        color: '#1a1a2f',
    },
    bundlePrice: {
        fontSize: 22,
        fontWeight: 700,
        letterSpacing: '-0.02em',
        color: '#1a1a2f',
    },

    /* ——— Order summary (pick) ——— */
    orderSummary: {
        border: '1px solid #e4e4e8',
        borderRadius: 10,
        padding: '16px 18px',
        marginBottom: 22,
    },
    summaryLabel: {
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '.05em',
        textTransform: 'uppercase',
        color: '#8a8a93',
        marginBottom: 12,
    },
    summaryRow: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 14,
        marginBottom: 8,
    },
    summaryItem: {
        color: '#4a4a52',
    },
    summaryValue: {
        fontWeight: 600,
    },
    summaryTotalRow: {
        borderTop: '1px solid #f0f0f3',
        paddingTop: 10,
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: 14,
    },
    summaryTotalLabel: {
        color: '#8a8a93',
    },
    summaryTotalValue: {
        fontWeight: 700,
        fontSize: 16,
    },
    summaryNote: {
        fontSize: 11,
        color: '#8a8a93',
        marginTop: 8,
    },

    /* ——— Footer buttons (pick) ——— */
    footer: {
        display: 'flex',
        gap: 10,
    },
    secondaryBtn: {
        flexShrink: 0,
        padding: '12px 24px',
        borderRadius: 4,
        backgroundColor: '#fff',
        color: '#4a4a52',
        border: '1px solid #e4e4e8',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        '&:hover': {
            backgroundColor: '#f5f5f8',
        },
    },
    primaryBtn: {
        flex: 1,
        width: '100%',
        padding: '12px 24px',
        borderRadius: 4,
        backgroundColor: ACCENT,
        color: '#fff',
        fontSize: 13,
        fontWeight: 600,
        letterSpacing: '.04em',
        textTransform: 'uppercase',
        '&:hover': {
            backgroundColor: '#000061',
        },
        '&.Mui-disabled': {
            backgroundColor: ACCENT,
            color: '#fff',
            opacity: 0.4,
        },
    },

}));
